import { render } from "./App.vue?vue&type=template&id=3e279158&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3e279158&lang=stylus"
import "./App.vue?vue&type=style&index=1&id=3e279158&lang=stylus&scoped=true"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e279158"]])

export default __exports__